import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { corPorIndice, TEXTO_PRIMARIO, TEXTO_SECUNDARIO } from './paletaResultados';

// Camada central só usada no modo rosca (innerRadius > 0) — total de
// respondentes no meio, aproveitando o espaço vazio que a pizza cheia não tem.
const RotuloCentral = ({ centerX, centerY, total }) => (
  <g>
    <text x={centerX} y={centerY - 6} textAnchor="middle" dominantBaseline="central" style={{ fontSize: 22, fontWeight: 700, fill: TEXTO_PRIMARIO }}>
      {total.toLocaleString('pt-BR')}
    </text>
    <text x={centerX} y={centerY + 14} textAnchor="middle" dominantBaseline="central" style={{ fontSize: 11, fill: TEXTO_SECUNDARIO }}>
      respondente(s)
    </text>
  </g>
);

// Pizza (2-3 opções) ou rosca (`variante="rosca"`, sempre 2 opções — ver
// CardPerguntaResultado.js). Sem legenda própria: a coluna "Valores" ao lado
// (CardPerguntaResultado.js) já lista cada opção com a mesma cor e o nome
// completo, então repetir isso dentro do gráfico é redundante — e a legenda
// do Nivo com largura fixa embolava nomes longos ("Praça Cravo Vermelho")
// uns em cima dos outros.
const GraficoPizza = ({ itens, totalRespostas, variante = 'pizza' }) => {
  if (!itens || itens.length === 0) {
    return <p className="text-sm text-gray-400 italic py-6 text-center">Nenhum dado registrado ainda.</p>;
  }

  const rosca = variante === 'rosca';
  const dados = itens.map((item) => ({ id: item.slug, label: item.label, value: item.votos }));
  const semVotos = dados.every((d) => d.value === 0);
  // Array na mesma ordem dos dados — o jeito confiável de passar cor
  // categórica pro Nivo Pie (a forma de função com {index} não funciona
  // aqui do mesmo jeito que no gráfico de barras; resultava em preto).
  const cores = dados.map((_, indice) => corPorIndice(indice));

  return (
    <div style={{ height: 260 }}>
      <ResponsivePie
        data={semVotos ? dados.map((d) => ({ ...d, value: 1 })) : dados}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        innerRadius={rosca ? 0.65 : 0}
        padAngle={1.5}
        cornerRadius={4}
        colors={cores}
        borderWidth={0}
        enableArcLinkLabels={false}
        arcLabel={(d) => (semVotos ? '' : `${Math.round((d.value / totalRespostas) * 100)}%`)}
        arcLabelsSkipAngle={12}
        arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2.6]] }}
        animate
        motionConfig="gentle"
        role="img"
        ariaLabel="Gráfico de proporção de votos por opção"
        layers={rosca
          ? ['arcs', 'arcLabels', ({ centerX, centerY }) => (
            <RotuloCentral key="rotulo-central" centerX={centerX} centerY={centerY} total={totalRespostas} />
          )]
          : ['arcs', 'arcLabels']}
        tooltip={({ datum }) => (
          <div className="bg-white shadow-lg rounded-lg pl-2.5 pr-3.5 py-2 border border-gray-100 flex items-stretch gap-2.5">
            <span className="w-[3px] rounded-full flex-shrink-0" style={{ backgroundColor: datum.color }} />
            <div>
              <p className="text-base font-semibold text-gray-900 leading-tight">
                {datum.value.toLocaleString('pt-BR')} <span className="text-xs font-normal text-gray-400">voto(s)</span>
              </p>
              <p className="text-xs text-gray-500">
                {datum.label} · {totalRespostas > 0 ? Math.round((datum.value / totalRespostas) * 1000) / 10 : 0}%
              </p>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default GraficoPizza;
